import React, { useEffect, useState, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import "../../App.css";
import "./DetailList.css";
import TelegramBackButton from "../../components/TelegramBackButton.jsx";
import NoResult from "../../assets/inbox_empty.png";
import defaultImage from "../../assets/default.png";
import LoadingAnim from "../../components/LoadingAnim";
import LazyLoad from "react-lazyload";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { useTranslation } from "react-i18next";

const DetailList = ({ isLoading, setPage, totalPages }) => {
  const location = useLocation();
  const { houses } = location.state || {};
  const { t } = useTranslation();
  const [filteredHouses, setFilteredHouses] = useState(houses || []);

  useEffect(() => {
    setFilteredHouses(houses || []);
  }, [houses]);

  const handleScroll = useCallback(() => {
    if (
      window.innerHeight + document.documentElement.scrollTop >=
      document.documentElement.offsetHeight - 100
    ) {
      if (!isLoading && houses.length / 10 < totalPages) {
        setPage((prevPage) => prevPage + 1);
      }
    }
  }, [isLoading, houses.length, totalPages, setPage]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return (
    <>
      <TelegramBackButton />
      <div className="p-4">
        {/* <h3 className="text-sm font-bold">{t("Nearby Your Location")}</h3> */}

        {isLoading && houses.length === 0 ? (
          <LoadingAnim />
        ) : filteredHouses.length > 0 ? (
          filteredHouses.map((property) =>
            property.houses.map((house) => (
              <div
                key={house.id}
                className="property-item rounded-lg bg-white mb-6"
              >
                <Link to={`/detail/${house.id}`} className="block">
                  <div className="property-image w-full">
                    {house.houseImage && house.houseImage.length > 0 ? (
                      <Swiper
                        spaceBetween={4}
                        slidesPerView={1}
                        pagination={{ clickable: true }}
                        modules={[Pagination]}
                      >
                        {house.houseImage.map((img, index) => (
                          <SwiperSlide key={index}>
                            <LazyLoad height={350} offset={100}>
                              <img
                                src={img.image}
                                alt="House"
                                className="w-full"
                                style={{ borderRadius: "15px", height: "350px" }}
                              />
                            </LazyLoad>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    ) : (
                      <img
                        src={defaultImage}
                        alt={house.title}
                        className="w-full"
                        style={{ borderRadius: "15px", height: "350px" }}
                      />
                    )}
                  </div>

                  <div className="p-1">
                    <h3 className="text-md font-bold truncate">
                      {house.title}
                    </h3>
                    <p className="text-xs text-gray-500">
                      {house.sub_description}
                    </p>
                    <p className="text-xs text-gray-500 mt-1">
                      {t("Posted by")} {" "}
                      <b>
                        @{property.userAccount.first_name}{" "}
                        {property.userAccount.last_name}
                      </b>
                    </p>
                    <p className="text-xs font-semibold">
                      {house.price} {house.unit} / {t("day")}
                    </p>
                    <p className="text-xs text-gray-500 flex items-center">
                      <i className="fa fa-map-marker mr-1"></i>
                      {house.city}, {house.specificAddress}
                    </p>
                  </div>
                </Link>
              </div>
            ))
          )
        ) : (
          <div className="flex flex-col items-center justify-center">
            <img src={NoResult} alt="No result found" className="mb-4 w-40" />
          </div>
        )}
        {isLoading && houses.length > 0 && <LoadingAnim />}
      </div>
    </>
  );
};

export default DetailList;
